"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createScript = void 0;
var createScriptRecord = new Map();
function createScript(url) {
    if (createScriptRecord.has(url)) {
        var res = createScriptRecord.get(url);
        return res;
    }
    var pms = new Promise(function (resolve, reject) {
        var _a;
        var id = (_a = url === null || url === void 0 ? void 0 : url.replace(/\//g, "")) === null || _a === void 0 ? void 0 : _a.replace(/\./g, "");
        var script = document.getElementById(id);
        var isHasScript = !!script;
        if (!script) {
            script = document.createElement("script");
            script.type = "text/javascript";
            script.id = id;
        }
        script.onload = function () {
            resolve(url);
        };
        script.onerror = function () {
            reject(url);
            createScriptRecord.delete(url);
        };
        script.src = url;
        if (!isHasScript) {
            document.getElementsByTagName("head")[0].appendChild(script);
        }
    });
    createScriptRecord.set(url, pms);
    return pms;
}
exports.createScript = createScript;
